module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00393.dd1c51d9.jpg";